export const enum DrawerSize {
  Normal = '26.375rem',
  ExtraSmall = '4.875rem',
}
